import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=dc8aa304&"
import script from "./SvgIcon.vue?vue&type=script&lang=js&"
export * from "./SvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports